import { ICONS } from 'components/Icons';
import { portableContents as portableContentsContent } from './OptionalExtrasContent';

export const portableContents = {
  code: 'PortableContents',
  label: 'Portable contents cover',
  image: ICONS.OPTIONAL_EXTRA.HOME.PORTABLE_CONTENTS,
  content: portableContentsContent,
};
